import React from "react";
import { useSelector } from "react-redux";
import LoyaltyRedeemSwitch from "components/brand-loyalty/LoyaltyRedeemSwitch";
import C from "Constants";
import { ItemsPaymentTotalDetail } from "components";
import {
  SALE_ITEMS_BLOCK_LOYALTY_MESSAGE,
  cartHasSalePricedItem,
} from "utils/discounts.utils";
const OrderPaymentInfo = ({
  getAreaDeliverFee,
  loyaltyPolicy,
  amountAfterDiscount,
  cartTotal,
  selectedStore,
  userWallet,
  handleConfirmDiscountLoyalty,
  redeemAmount,
}) => {
  const cart = useSelector((state) => state?.cart?.cart);
  const hasSalePricedItem = cartHasSalePricedItem(cart);
  return (
    <ItemsPaymentTotalDetail
      original={cartTotal}
      deliveryFee={getAreaDeliverFee()?.deliveryFee || 0}
      taxRate={selectedStore?.taxRate || 0}
      amountAfterDiscount={amountAfterDiscount}
      userWallet={userWallet}
    >
      {loyaltyPolicy?.isLoyaltyActive && userWallet > 0 && (
        <LoyaltyRedeemSwitch
          loyaltyPolicy={loyaltyPolicy}
          cartTotal={cartTotal}
          amountAfterDiscount={cartTotal}
          userWallet={userWallet}
          switchLoyaltyStatus={() => handleConfirmDiscountLoyalty(C.LOYALTY)}
          redeemAmount={redeemAmount}
          unavailableReason={
            hasSalePricedItem ? SALE_ITEMS_BLOCK_LOYALTY_MESSAGE : null
          }
        />
      )}
    </ItemsPaymentTotalDetail>
  );
};
export default OrderPaymentInfo;
